import { SeuComputationCombination } from '@seu-types';

export const SEU_MOCK_COMPUTATION_COMBINATIONS: SeuComputationCombination[] = [
  {
    interconnectionId: '10602',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10529', '10673'],
  },
  {
    interconnectionId: '10603',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10532'],
  },
  {
    interconnectionId: '10604',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10535'],
  },
  {
    interconnectionId: '10605',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10537'],
  },
  {
    interconnectionId: '10606',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10540', '10541', '10542', '10544'],
  },
  {
    interconnectionId: '10607',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10543'],
  },
  {
    interconnectionId: '10614',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10550'],
  },
  {
    interconnectionId: '10661',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10600'],
  },
  {
    interconnectionId: '10693',
    globalParameterSetId: '1459',
    operatingConditionIds: ['10638'],
  },
  {
    interconnectionId: '10602',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10529', '10673'],
  },
  {
    interconnectionId: '10603',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10532'],
  },
  {
    interconnectionId: '10604',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10535'],
  },
  {
    interconnectionId: '10605',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10537'],
  },
  {
    interconnectionId: '10606',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10540', '10541', '10542', '10544'],
  },
  {
    interconnectionId: '10607',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10543'],
  },
  {
    interconnectionId: '10614',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10550'],
  },
  {
    interconnectionId: '10661',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10600'],
  },
  {
    interconnectionId: '10693',
    globalParameterSetId: '10010',
    operatingConditionIds: ['10638'],
  },
];
